import axiosClient from "../../../../axiosClient"

// Frozen consumer reports of a TruCheck (original + supplemental of a USCIS revocation), newest first.
// The backend returns the audience matching the caller's role (QA: full, client: immigration class hidden).
const consumerReportSnapshots = async (preCheckId) => {
    const result = await axiosClient.get(`/pre-check-consumer-report-snapshots/${preCheckId}`)
    return result.data?.snapshots || []
}

export default consumerReportSnapshots
